namespace Gordic.Adm.WebControls {
    export interface AdmAuditPristupuOptions {
        /** SXS */
        sxs: string;
        /** Typ objektu */
        typ_obj: number;
    }

    /** Nový audit přístupů */
    export class AdmAuditPristupuNew {
        private sxs: string;
        private typ_obj: number;
        private grid: JQuery<HTMLElement>;
        private dataListDescription: General.ApplicationInterface.GDataListDescription

        public constructor(options: AdmAuditPristupuOptions) {
            this.sxs = (options.sxs ?? "").toString();
            this.typ_obj = options.typ_obj;
        }

        private createGrid(panel: JQuery<HTMLElement>, isPanel: boolean = true) {
            if (!this.grid) {
                var _this = this;
                Gordic.Isl.AdmObjektZmena.listWithMeta({
                    filters: { sxs: _this.sxs, typ_obj: _this.typ_obj },
                    fragments: []
                }).get().then((data, metadata) => {
                    if (data.meta) {
                        _this.dataListDescription = data.meta;
                        _this.grid = $("<div>").appendTo(panel).ggrid({
                            emptyMessage: (data.meta.data_right?.Read == false) ? "<i>jres:33000435</i>" : undefined, //RC 33000435 : Nemáte oprávnění prohlížet historii záznamů!
                            columns: Gordic.Adm.WebControls.GAdmGridFunctions.createGridGormatAuditPristupu(_this.dataListDescription, "dat_zmena,nazev_rf,por_cislo"),
                            defaultProfile: {
                                sort: "!dat_zmena"
                            }
                        })
                        if (isPanel == false)
                            _this.grid.gautofit({ resizersOnTab: false })
                    }
                }).then(() => {
                    this.loadData();
                })
            } else {
                this.loadData();
            }
        }

        private loadData() {
            Gordic.Isl.AdmObjektZmena.list({
                filters: { sxs: this.sxs, typ_obj: this.typ_obj },
                fragments: []
            }).getData().done((data) => {
                this.grid.ggrid("setData", data);
            })
        }

        getSidePanel(): Gordic.Gin.DetailBuilder.GDetailBuilderSbpanelOptionsId {
            return {
                leaf: "jres:32000146",
                id: "panelAuditPristupu",
                caption: "jres:32000145",
                icon: "gi-nahled",
                side: "right",
                open: (ev, obj) => {
                    this.createGrid($(ev.target));
                }
            }
        }

        getPanel(): Gordic.Gin.DetailBuilder.TabParamsId {
            return {
                tabParams: {
                    id: "tab-audit-pristupu",
                    title: "jres:32000145",
                    opened: true,
                    locked: true,
                    group: { id: "_tab-audit-pristupu" }
                },
                init: (tab) => { this.createGrid(tab, false) }
            }
        }

        getGroup(): IGTabGroupOptions {
            return { id: "_tab-audit-pristupu", caption: "jres:32000145" }
        }
    }
}